"use strict";

import React from "react";

import DesignThemeStore from "../../stores/DesignThemeStore";

function withData(Component) {
  return class extends React.Component {
    constructor(props) {
      super(props);

      this.state = {
        designTheme: DesignThemeStore.getTheme(),
        designColors: DesignThemeStore.getColors(),
      };
    }

    componentDidMount() {
      this.storeUnsubscribe = DesignThemeStore.listen(this._onStoreChange);
    }

    componentWillUnmount() {
      this.storeUnsubscribe();
    }

    _onStoreChange = () => {
      this.setState({
        designTheme: DesignThemeStore.getTheme(),
        designColors: DesignThemeStore.getColors(),
      });
    };

    render() {
      return (
        <Component
          designTheme={this.state.designTheme}
          designColors={this.state.designColors}
          {...this.props}
        />
      );
    }
  };
}

export default withData;
